module.exports = __webpack_public_path__ + "img/custom.8db870da.png";